<template>
  <pt-sheet>
    <v-card-title v-if="!disableTitle">
      <div class="header">
        <h2>
          {{ checklistItem.name }}
        </h2>
      </div>
    </v-card-title>
    <slot></slot>
    <!-- Expected to be used for buttons provided by parent component -->
    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <v-container pa-0>
          <div
            class="question-group"
            v-for="(questionGroup, index) in checklistItem.questionGroups"
            :key="questionGroup.id"
          >
            <v-divider v-if="index > 0" class="my-8"></v-divider>
            <question
              v-for="question in questionGroup.questions"
              :key="question.dataPointId"
              :question="question"
              :disabled="disabled"
              :satisfiedRules="satisfiedRules"
            />
          </div>
        </v-container>
      </v-form>
    </v-card-text>
  </pt-sheet>
</template>

<script>
import Question from "../components/question/Question";
import PtSheet from "./PtSheet.vue";
import { put } from "@/services/request";
import { customerEvdChecklistByIdAPI } from "@/services/api";
import hasNotifications from "@/mixins/has-notifications";

export default {
  name: "EvdForm",
  mixins: [hasNotifications],
  props: {
    checklistItem: {},
    disabled: {
      type: Boolean,
      default: false
    },
    disableTitle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PtSheet,
    Question
  },
  data() {
    return {
      formValid: false
    };
  },
  computed: {
    satisfiedRules() {
      if (!this.checklistItem || !this.checklistItem.questionGroups) return [];
      const ruleNameMap = this.checklistItem.questionGroups
        .flatMap(({ questions }) => questions)
        .flatMap(({ expressions }) => expressions)
        .reduce((acc, { ruleName, satisfied }) => {
          if (acc[ruleName] === false) {
            // do nothing
          } else if (satisfied === false) {
            acc[ruleName] = false;
          } else if (satisfied === true) {
            acc[ruleName] = true;
          }
          return acc;
        }, {});

      return Object.keys(ruleNameMap).filter(ruleName => ruleNameMap[ruleName]);
    }
  },
  methods: {
    save(markComplete = false) {
      return put(
        customerEvdChecklistByIdAPI.getUrl({
          customerId: this.checklistItem.clientId,
          checklistItemId: this.checklistItem.id,
          markComplete
        }),
        this.checklistItem
      ).catch(() => {
        this.showMessage({ text: "Failed to save form", mode: "error" });
        return Promise.reject();
      });
    },
    validate() {
      this.$emit("form-valid", this.formValid);
    }
  },
  watch: {
    formValid(val) {
      this.$emit("form-valid", val);
    }
  }
};
</script>

<style lang="sass" scoped>
.save-changes-button
  margin: 0 8px
</style>
